import { SurveyProgressButtons as ReactSurveyProgressButtons } from 'survey-react-ui';
import { get } from 'lodash';
import { Fragment } from 'react';

import { Content } from '../../Content';

import { CURRENT_PAGE_CLASS_NAME } from './SurveyProgressButtons.const';

export class SurveyProgressButtons extends ReactSurveyProgressButtons {
  render(): JSX.Element {
    const elements = this.getListElements();

    const currentIndex =
      elements.findIndex((item) =>
        get(item, ['props', 'className'], '').includes(CURRENT_PAGE_CLASS_NAME)
      ) || 0;

    const currentStep = currentIndex + 1;

    if (elements.length === 1) return null;

    return (
      <Fragment>
        <div
          style={{ display: 'none' }}
          className={this.css.progressButtonsListContainer}
          // @ts-expect-error
          ref={this.listContainerRef}
        />
        <Content.Progress value={currentStep / elements.length} />
      </Fragment>
    );
  }
}
